export default __webpack_public_path__ + "static/media/coffee-cup.c4b387c0.svg";